import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  enquiryId: "",
  nric: "",
  age: "",
  language: "EN",
  furtherEnquire: "0",
  service: "",
  mobile: ""
};

export const appointmentSlice = createSlice({
  name: "appointment",
  initialState,
  reducers: {
    changeEnquiryId: (state, action) => {
      state.enquiryId = action.payload;
    },
    changeNric: (state, action) => {
      state.nric = action.payload;
    },
    changeAge: (state, action) => {
      state.age = action.payload;
    },
    changeLanguage: (state, action) => {
      state.language = action.payload;
    },
    changeFurtherEnquire: (state, action) => {
      state.furtherEnquire = action.payload;
    },
    changeService: (state, action) => {
      state.service = action.payload;
    },
    changeMobile: (state, action) => {
      state.mobile = action.payload;
    },
    clearAppointment: (state) => {
      state.enquiryId = "";
      state.nric = "";
      state.age = "";
      state.language = "EN";
      state.furtherEnquire = "0";
      state.service = "";
      state.mobile = "";
    },
    updateAppointmentInfo: (state, action) => {
      const {
        enquiry_for_id,
        visitor_identity,
        other_equiry_service_id,
        prefer_lang,
        contact_no,
        birth_year
      } = action.payload;
      state.enquiryId = enquiry_for_id;
      state.nric = visitor_identity;
      state.language = prefer_lang;
      state.service = other_equiry_service_id || "";
      state.mobile = contact_no?.trim();
      state.age = birth_year;
    }
  }
});

export const {
  changeEnquiryId,
  changeNric,
  changeAge,
  changeLanguage,
  changeFurtherEnquire,
  changeService,
  changeMobile,
  clearAppointment,
  updateAppointmentInfo
} = appointmentSlice.actions;

export default appointmentSlice.reducer;
